import React from 'react';
import {
    PageContainer,
    HeaderSection,
    TitleContainer,
    MainTitle,
    SubTitle,
    ContactButton,
    HeaderImageContainer,
    KeyAspectsSection,
    KeyAspectsTitle,
    KeyAspectsSubtitle,
    FeatureSection,
    EnhancedEfficiencyBlock,
    ModularStructureBlock,
    StagesBlock,
    DynamicStylesBlock,
    TextContent,
    ImageContainer,
    Heading,
    Paragraph,
    Image,
    FeatureTitle
} from './EffectiveSassDevelopmentStyles';
import Home from '../Home';

// Placeholder Images (Replace these with actual imported images in a real project)
const PlaceholderSassImage = 'SASS_DEVELOPMENT_ILLUSTRATION.png';
const PlaceholderStagesImage = 'SASS_DEVELOPMENT_LIFECYCLE.png';
const PlaceholderArchitectureImage = 'SINGLE_TENANT_ARCHITECTURE.png';

const SAASDevelopmentt = () => {
    // Content structure based on the uploaded image
    return (
      <Home>
        <PageContainer>
            {/* 1. Header/Hero Section */}
            <HeaderSection>
                <TitleContainer>
                    <MainTitle>EFFECTIVE SASS</MainTitle>
                    <SubTitle>DEVELOPMENT</SubTitle>
                    <ContactButton>Contact Us</ContactButton>
                </TitleContainer>
                <HeaderImageContainer /> {/* Placeholder for the complex diagram */}
            </HeaderSection>

            {/* 2. Key Aspects Section (Dark Grey Banner) */}
            <KeyAspectsSection>
                <KeyAspectsTitle>Key Aspects of Sass Development</KeyAspectsTitle>
                <KeyAspectsSubtitle>
                    Our Sass development delivers top rankings and promised results, earning us delighted feedback from satisfied clients. (SRK Softwares Promise)
                </KeyAspectsSubtitle>
            </KeyAspectsSection>

            {/* 3. Feature Blocks Section (White Background) */}
            <FeatureSection>

                {/* ENHANCED CSS EFFICIENCY Block */}
                <EnhancedEfficiencyBlock>
                    <TextContent>
                        <FeatureTitle>ENHANCED CSS EFFICIENCY</FeatureTitle>
                        <Paragraph>
                            Sass brings a revolution to CSS development by introducing features like nesting, variables, mixins, and functions. This significantly improves code structure, reduces the amount of CSS code and removes unnecessary repetitions. This leads to a smoother, faster, and more enjoyable coding experience. It also helps in organizing styles logically and making changes across the application much simpler. This means less time debugging and more time developing.
                        </Paragraph>
                        <Paragraph>
                            One of the great things about Sass is its use of variables. This lets you define a value once and use it many times. Then again, making sure everything looks the same and is easy to change. Mixins are equally powerful. They allow developers to create groups of styles that they can use in different places without having to copy and paste them, minimizing the need to write the same code over and over.
                        </Paragraph>
                    </TextContent>
                    <ImageContainer>
                        <Image src={PlaceholderSassImage} alt="Sass Illustration" />
                    </ImageContainer>
                </EnhancedEfficiencyBlock>

                {/* MODULAR STRUCTURE AND NESTING Block */}
                <ModularStructureBlock>
                    <TextContent>
                        <FeatureTitle>MODULAR STRUCTURE AND NESTING</FeatureTitle>
                        <Paragraph>
                            Sass is a next step beyond what CSS offers, and even CSS is a step beyond. Among its remarkable features is nesting. Picture this: nesting organizes your CSS in a way that makes it look like it takes up your code and simplifies finding styles. But Sass goes far beyond.
                        </Paragraph>
                        <Paragraph>
                            It's also about a modular approach that breaks down big stylesheets into smaller, easier-to-manage pieces. This structure makes style updates a breeze. Sass offers partials and the ability to split stylesheets into files, organizing them files. This leads to better organization, streamlined teamwork, and efficient maintenance.
                        </Paragraph>
                    </TextContent>
                    <ImageContainer>
                        {/* Placeholder for the Stages of the Sass Software Development Life Cycle diagram */}
                    </ImageContainer>
                </ModularStructureBlock>

                {/* STAGES OF THE SASS SOFTWARE DEVELOPMENT LIFE CYCLE Block */}
                <StagesBlock>
                    <TextContent>
                        <FeatureTitle>Stages of the Sass Software Development Life Cycle</FeatureTitle>
                        <Paragraph>
                            [Descriptive text about the stages would go here, complementing the diagram.]
                        </Paragraph>
                    </TextContent>
                    <ImageContainer>
                        <Image src={PlaceholderStagesImage} alt="Sass Development Life Cycle Diagram" />
                    </ImageContainer>
                </StagesBlock>

                {/* DYNAMIC AND EXTENSIBLE STYLES Block */}
                <DynamicStylesBlock>
                    <TextContent>
                        <FeatureTitle>DYNAMIC AND EXTENSIBLE STYLES</FeatureTitle>
                        <Paragraph>
                            Sass simplifies and makes style look good. It is all about making your style dynamic and extensible. Imagine having dynamic styles that respond to different situations. How does it work? Conditional styles and loops. Sass has functions that allow you to tweak styles based on what users do, what device they are using, or even the time of day. Pretty cool, right?
                        </Paragraph>
                        <Paragraph>
                            But that’s just the beginning. Sass goes even further by offering a powerful set of programming tools, similar to a regular code language, including control directives, loops, and functions. They supercharge your development process, allowing you to generate complex style variations, handle cool effects, or manage complex layouts. These extensions provide true programming for styles.
                        </Paragraph>
                        <Paragraph>
                            Sass also gives you the freedom to customize your workflow. Developers can mix and match Sass features, including mixins, to set up the best environment that suits their personal preferences. This means more efficiency and a smoother way of working. (SRK Softwares)
                        </Paragraph>
                    </TextContent>
                    <ImageContainer>
                        <Image src={PlaceholderArchitectureImage} alt="Single Tenant App Architecture Diagram" />
                    </ImageContainer>
                </DynamicStylesBlock>

            </FeatureSection>
        </PageContainer>
        </Home>
    );
};

export default SAASDevelopmentt;

